var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.79 5.00047L13.23 0.890474C11.6036 -0.296835 9.39636 -0.296835 7.77 0.890474L2.22 5.00047C1.14544 5.77461 0.506103 7.01612 0.5 8.34047V15.7705C0.560025 18.1637 2.54665 20.0564 4.94 20.0005H16.06C18.4534 20.0564 20.44 18.1637 20.5 15.7705V8.33047C20.4914 7.01184 19.8567 5.77576 18.79 5.00047ZM19 15.7705C18.9404 17.3355 17.6251 18.5568 16.06 18.5005H4.94C3.37698 18.5512 2.06502 17.333 2 15.7705V15.7706C2.06502 17.333 3.37698 18.5513 4.94 18.5006H16.06C17.6251 18.5568 18.9404 17.3355 19 15.7706V15.7705ZM17.89 6.21049C18.4948 6.63524 18.8871 7.29312 18.9792 8.0168C18.8871 7.29314 18.4948 6.63529 17.89 6.21055L12.34 2.10055C11.2439 1.30013 9.75609 1.30013 8.66 2.10055L3.11 6.20055C2.49684 6.63839 2.10282 7.31337 2.01743 8.05304C2.1028 7.31335 2.49682 6.63834 3.11 6.20049L8.66 2.10049C9.75609 1.30007 11.2439 1.30007 12.34 2.10049L17.89 6.21049Z",
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.7505H6C5.58579 13.7505 5.25 14.0863 5.25 14.5005C5.25 14.9147 5.58579 15.2505 6 15.2505H15C15.4142 15.2505 15.75 14.9147 15.75 14.5005C15.75 14.0863 15.4142 13.7505 15 13.7505Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCopy);
export default __webpack_public_path__ + "static/media/Home - Copy.d9d421c1426b98c9924a5dc84e4fe5e9.svg";
export { ForwardRef as ReactComponent };